import React from 'react';
import { useRouter } from 'next/router';

import sortValuesBeautifulPhone from '@/constants/sortValuesBeautifulPhone';
import { SectionTitle, TextBlock } from '@/ui/index';
import CreateOwnPhoneInput from '@/ui/CreateOwnPhoneInput/CreateOwnPhoneInput';

import styles from './FindYourNumberFlow.module.scss';

const sortValuesData = sortValuesBeautifulPhone();

const FindYourNumberFlow = ({ data }) => {
  const { title = '', description = '', ...rest } = data;
  const router = useRouter();
  const [tabs] = React.useState(['All', 'Bronze']);
  const [value, onChange] = React.useState(['', '', '', '', '', '', '']);
  const [sortValue, setSortValue] = React.useState(sortValuesData[0]);

  // React.useEffect(() => {
  //   if (router.isReady) {
  //     if (router.query?.value) onChange(router.query.value);
  //     if (router.query?.sort)
  //       setSortValue(
  //         sortValuesData.find((item) => item.id === router.query.sort),
  //       );
  //   }
  // }, [router.isReady, router.query.sort, router.query.value]);

  const onLoadMore = () => {
    // router.push({
    //   pathname: router.pathname,
    //   query: {
    //     ...router.query,
    //     value,
    //     sort: sortValue.id,
    //   },
    // });
  };

  const onSubmit = () => {
    // router.push({
    //   pathname: router.pathname,
    //   query: {
    //     ...router.query,
    //     value,
    //     sort: sortValue.id,
    //   },
    // });
  };

  const onReset = () => {
    router.push('/beautiful-number');
  };

  return (
    <div className={'wrapper little-margin'}>
      <div className={styles.intro}>
        <SectionTitle className={styles.title} titleModify={'title--large'}>
          {title}
        </SectionTitle>
        <TextBlock className={'text--large'}>{description}</TextBlock>
      </div>
      {tabs && (
        <CreateOwnPhoneInput
          titles={rest}
          onLoadMore={onLoadMore}
          tabs={tabs}
          sortValue={sortValue}
          setSortValue={setSortValue}
          onChange={onChange}
          value={value}
          onSubmit={onSubmit}
          onReset={onReset}
          sortData={sortValuesData}
        />
      )}
    </div>
  );
};

export default FindYourNumberFlow;
